export const packagePropertiesRows = (response, message) => {
    if (response instanceof Error) throw response;
    const rows = response?.data?.data;
    // An unavailable API route can return the SPA's HTML with HTTP 200.
    // Never pass undefined to DevExtreme's raw loader: it leaves the load pending.
    if (!Array.isArray(rows)) throw new Error(message);
    return rows;
};

export const packagePropertiesMutation = (response, message) => {
    if (response instanceof Error) throw response;
    if (!response || typeof response.data === 'string' && response.data.trim()) throw new Error(message);
    return response;
};
